import { createFileRoute } from "@tanstack/react-router";
import { LiderZakupyFormPage } from "@/features/contracts/lider-zakupy-form-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/kontrakty/lider-zakupy/nowy")({
	component: LiderZakupyFormPage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.kontrakty.lider-zakupy",
			location.pathname,
		);
	},
});
